<!--  用户所在区域下属所有区域-->
<template>
  <el-select-tree
    @change="selectOne"
    :data="options_area"
    :props="treeProps"
    v-model="selectID"
    :disabled="disabled"
    :default-expand-all="true"
    :check-strictly="true"
    placeholder="默认"></el-select-tree>
</template>

<script>
import {treeDataTranslate} from '@/utils'

export default {
  name: 'area-use',
  data() {
    return {
      selectID: this.id,
      treeProps: {
        value: 'id',
        children: 'children',
        label: 'areaName'
      },
      options_area: [],
    }
  },
  props: {
    id: [String, Number],
    parentId: {
      type: [Number, String],
      default: null
    },
    level: String,
    parentIdPath: String,
    disabled: Boolean
  },
  watch: {
    id: function (newVal, oldVal) {
      this.selectID = newVal;
    },
    selectID: function (newVal, oldVal) {
    },
    parentId: function (newVal, oldVal) {
      this.getBankCondition();
    }
  },
  created() {
    this.getBankCondition();
  },
  methods: {
    selectOne(event, item) {
      this.$emit('select', event);
      this.$emit("update:id", item.id);
      this.$emit("update:level", item.level);
      this.$emit("update:parentIdPath", item.parentIdPath);
    },
    getBankCondition() {
      this.$http({
        url: this.$http.adornUrl('/sys/area/getSupportAreas'),
        method: 'get',
        params: this.$http.adornParams(this.parentId ? {parentId: this.parentId} : {})
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.options_area = treeDataTranslate(data.data, "id", "parentId")
          let current = data.data.filter((item) => item.id == this.id)
          if (current == undefined || current.length == 0) {
            this.id = ''
            this.$emit("update:id", this.id);
          }
        }
      }).catch((err) => {
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/area/area-use.vue